import Vuex from 'vuex'
const store = new Vuex.Store({
  state: {
    calendarDisplayMode: (localStorage && localStorage.calendarDisplayMode) || "solve",
  },
	mutations: {
		setCalendarDisplayMode (state, mode) {
			state.calendarDisplayMode = mode;
		}
	}
})
export default store;
